module.exports = "/lucky-balls/img/jackpot/005.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/jackpot/005.png
// module id = 1105
// module chunks = 0